export default "__VITE_ASSET__WkJRgfR3__"